import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { GridOptions } from "ag-grid-community";
import { QuoteService } from '../../../quote/quote.service';
import { formatDate } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'ngx-webstorage';
import { PolicyService } from '../../../policy/policy.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ag-documents',
  templateUrl: './ag-documents.component.html',
  styleUrls: ['./ag-documents.component.css', '../../quote.component.css']
})
export class AgDocumentsComponent implements OnInit {
  rowData: any;
  rowDataPeliwica: any;

  constructor(private quoteService: QuoteService, private policyService: PolicyService,
    private _snackBar: MatSnackBar, private modalService: NgbModal, private sessionSt: LocalStorageService) { }

  @Input() quote;
  isPolicy: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    if (this.sessionSt.retrieve('quote_ref_id')) { this.isPolicy = true; }
    if (this.quote && this.quote.documents) {
      const documents = Object.keys(this.quote.documents).map(key => ({ key: key, value: this.quote.documents[key] }));
      this.rowData = documents;
      this.getDocuments();
    }
  }

  isAdmin: boolean = false;
  isInsurer: boolean = false;
  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) { this.isAdmin = true; }
    if (this.sessionSt.retrieve('is_insurer')) { this.isInsurer = true; }
  }

  getDocuments() {
    let type = (this.quote.is_policy == 1) ? 2 : 1;
    this.quoteService.getQuoteDocuments(this.quote.id, type)
      .subscribe(
        (response: any) => {
          if (response.success) {
            response.result.forEach((res) => {
              res.is_policy = this.quote.is_policy;
              if (this.sessionSt.retrieve('is_insurer')) { res.isInsurer = true; }
            });
            this.rowDataPeliwica = response.result;
          }
        },
        (error) => { }
      );
  }

  gridOptions: GridOptions = { onGridReady: () => { this.gridOptions.api.sizeColumnsToFit(); } };
  columnDefs = [
    { headerName: 'Document Name', field: 'key', sortable: true, width: 500, filter: false, cellRenderer: function (params) { return params.data.value.name; } },
    { headerName: 'Document Type', field: 'key', sortable: true, width: 500, filter: false, cellRenderer: function (params) { return params.data.value.type; } },
    { headerName: null, width: 130, filter: false, type: 'rightAligned', cellRenderer: function (params) { return '<a class="ml-2" href="' + params.data.value.file_path + '" download target="_blank" title="Download" style="font-size: 18px;color: #138a51;"><i class="mdi mdi-cloud-download" data-action-type="download"></i></a>'; } }
  ];
  columnDefsPeliwica = [
    { headerName: 'Document Name', field: 'key', sortable: true, width: 500, filter: false, cellRenderer: function (params) { return params.data.title; } },
    { headerName: 'Document Version', field: 'quote_version', sortable: true, width: 500, filter: false, cellRenderer: function (params) { return params.data.quote_version; } },
    { headerName: null, width: 130, filter: false, type: 'rightAligned', cellRenderer: function (params) { return '<a class="ml-2" title="Download" style="font-size: 18px;color: #138a51;"><i class="mdi mdi-cloud-download" data-action-type="download"></i></a>'; } }
  ];

  documentsEditMode: boolean = false;
  documentID: string = '';
  onGridRowClicked(e: any, content, documentsDelete) {
    if (e) {
      let actionType = e.event.target.getAttribute("data-action-type");
      switch (actionType) {
        case "download": { this.quoteService.downloadDocs(e.data); break; }
      }
    }
  }

  docTitle: string = '';
  fileToUpload: File = null;
  openDocumentsPopup(content) {
    this.documentID = '';
    this.docTitle = '';
    this.fileToUpload = null;
    this.quote.quote_document = '';
    this.documentsEditMode = false;
    this.modalService.open(content, { centered: true });
  }

  getUploadedFile(files) {
    this.fileToUpload = files.item(0);
    this.quote.quote_document = this.fileToUpload.name;
  }

  documentUpload() {
    let formData = new FormData();
    formData.append("file_name", this.fileToUpload);
    formData.append("quote_id", this.quote.id);
    formData.append("broker_id", this.quote.broker_id);
    formData.append("title", this.docTitle);
    this.quoteService.saveQuoteDocument(formData, this.quote.is_policy)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.getDocuments();
            this.modalService.dismissAll();
            this._snackBar.open('Document uploaded.', '', { duration: 5000 });
          } else {
            this._snackBar.open('Unable to upload document.', '', { duration: 5000, panelClass: 'text-danger' });
          }
        });
  }

  updateDocument() {
    let data: any = { document_id: this.documentID, title: this.docTitle };
    this.quoteService.updateDocument(data)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.modalService.dismissAll();
            this._snackBar.open(response.message, '', { duration: 5000 });
          } else {
            this._snackBar.open('Unable to update title.', '', { duration: 5000, panelClass: 'text-danger' });
          }
        });
  }

  deleteDocument() {
    let data: any = { document_id: this.documentID };
    this.quoteService.deleteDocument(data)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.modalService.dismissAll();
            this._snackBar.open(response.message, '', { duration: 5000 });
          } else {
            this._snackBar.open(response.message, '', { duration: 5000, panelClass: 'text-danger' });
          }
        });
  }

  schMsg: string = '';
  regenerate_schedule(reSchedule) {
    this.policyService.regenerateSchedule(this.quote.id, this.quote.is_policy)
      .subscribe(
        (response: any) => {
          this.getDocuments();
          this.schMsg = response.message;
          this.modalService.open(reSchedule, { centered: true });
        });
  }
}
